import "./Training.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import FormaciNDeLite from "./sections/FormaciNDeLite";
import NuestroEquipoEnAcciN from "./sections/NuestroEquipoEnAcciN";
import NeteAGrupoPoseidN from "./sections/NeteAGrupoPoseidN";
import InformaciNCorporativa from "@/reusable_sections/Footer";
export default function TrainingPage() {
  return <div>
      <NavegaciNPrincipal />
      <FormaciNDeLite />
      <NuestroEquipoEnAcciN />
      <NeteAGrupoPoseidN />
      <InformaciNCorporativa />
    </div>;
}